module.exports = __webpack_public_path__ + "static/media/meme_9.d18cfc86.png";